module.exports = __webpack_public_path__ + "static/media/medita_logo_horizontal.f600a595.png";